import React, { PureComponent } from 'react';
import upperFirst from 'lodash/upperFirst';
import PropTypes from 'prop-types';

import { setWindowLocation } from '@eb/http';
import { MediaCardContent } from '@eb/eds-media-card-content';
import { Card } from '@eb/eds-card';
import { GRID_TYPE, STANDARD_STYLE } from '@eb/eds-media-card-content';
import { Trending as TrendingSvg } from '@eb/eds-iconography';

import { BucketHeader } from '../../../../components/BucketHeader';
import { SeeMoreButton } from '../../../../components/SeeMoreButton';
import {
    GA_CITY_BROWSE_CATEGORY,
    GA_VIEW_TRENDING_SEARCH_ACTION,
    GA_VIEW_ALL_TRENDING_SEARCHES_ACTION,
} from '../../../../constants/analytics';
import { getTrendingSearchesPathForLocation } from '../../../../utils/trending';

const httpRefererWasSearchEngine = (httpReferer) =>
    httpReferer.search('google|bing|yahoo') >= 0;

const _formattedTitle = (id, searchTerm) => (
    <span className="eds-text-bl eds-text-weight--regular eds-text-bm eds-text-color--ui-blue">
        {id + 1}. {upperFirst(searchTerm)}
    </span>
);

const _getTrendingSearchCards = (content, trackClick) => {
    const classes =
        'eds-l-pad-hor-3 eds-l-pad-vert-2 eds-g-cell eds-g-cell-md-3-12 eds-g-cell-12-12';

    return content.map(({ id, searchTerm, searchPath }) => (
        <div key={id} className={classes}>
            <Card style="simple">
                <MediaCardContent
                    style={STANDARD_STYLE}
                    type={GRID_TYPE}
                    linkUrl={searchPath}
                    title={_formattedTitle(id, searchTerm)}
                    onClick={trackClick.bind(this, searchTerm)}
                    shouldHideImage={true}
                />
            </Card>
        </div>
    ));
};

const _handleSeeMoreClick = (
    httpReferer,
    currentPlace,
    trackGAEventOnPageUnload,
    action,
    url,
) => {
    if (httpRefererWasSearchEngine(httpReferer)) {
        trackGAEventOnPageUnload({
            category: GA_CITY_BROWSE_CATEGORY,
            action,
            label: currentPlace,
        });
    }

    /* Need to fire tracking action on the seemore, so necessary to
    manually set windowlocation rather that relying on the link. */
    if (url) {
        setWindowLocation(url);
    }
};

const _handleSelectSearchClick = (httpReferer, searchTerm, trackGAEvent) => {
    if (httpRefererWasSearchEngine(httpReferer)) {
        trackGAEvent({
            category: GA_CITY_BROWSE_CATEGORY,
            action: GA_VIEW_TRENDING_SEARCH_ACTION,
            label: searchTerm,
            requestPath: window.location.pathname,
        });
    }
};

export class TrendingSearchesBucket extends PureComponent {
    static propTypes = {
        content: PropTypes.arrayOf(
            PropTypes.shape({
                searchTerm: PropTypes.string.isRequired,
                formattedSearch: PropTypes.string.isRequired,
            }),
        ),
        name: PropTypes.string,
        httpReferer: PropTypes.string,
        trackGAEvent: PropTypes.func,
        trackGAEventOnPageUnload: PropTypes.func,
        currentPlace: PropTypes.string,
        seeMoreMarkedNoFollow: PropTypes.bool,
    };

    render() {
        const {
            currentPlace,
            content,
            name,
            httpReferer,
            locationSlug,
            trackGAEvent,
            trackGAEventOnPageUnload,
            seeMoreMarkedNoFollow = false,
        } = this.props;
        const trendingSearchesPath = getTrendingSearchesPathForLocation(
            locationSlug,
        );

        return (
            <div>
                <BucketHeader
                    title={name}
                    iconType={<TrendingSvg />}
                    linkUrl={trendingSearchesPath}
                    template="trending_searches"
                    trackSeeMore={_handleSeeMoreClick.bind(
                        null,
                        httpReferer,
                        currentPlace,
                    )}
                    trackGAEvent={trackGAEvent}
                    gaAction={GA_VIEW_ALL_TRENDING_SEARCHES_ACTION}
                    seeMoreMarkedNoFollow={seeMoreMarkedNoFollow}
                />
                <div className="eds-g-group">
                    {_getTrendingSearchCards(
                        content,
                        _handleSelectSearchClick.bind(
                            null,
                            httpReferer,
                            trackGAEvent,
                        ),
                    )}
                </div>
                <div className="eds-l-pad-top-6">
                    <div className="eds-show-down-sn eds-align--center">
                        <div className="eds-g-cell">
                            <SeeMoreButton
                                linkUrl={trendingSearchesPath}
                                title={name}
                                trackClick={_handleSeeMoreClick.bind(
                                    null,
                                    httpReferer,
                                    currentPlace,
                                    trackGAEventOnPageUnload,
                                )}
                                gaAction={GA_VIEW_ALL_TRENDING_SEARCHES_ACTION}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
